import { Component, OnInit, Inject } from '@angular/core';
import { Validators, FormBuilder } from '@angular/forms';

import { cellPhoneCommonValidators } from '@shared/core/validators/cell-phone.shared.validator';
import * as Services from '@shared/core/services';
import * as Tokens from '@shared/core/tokens';
import { Controllers } from '@shared/core/controllers';

import { FormTypesComponent } from '../form-types.shared.component';
import { ILoyaltyAppCountryAssignmentModel } from '@shared/state';

@Component({
    selector: 'shared-form-for-cell-sign-in',
    templateUrl: './form-for-cell-sign-in.shared.component.html',
    styleUrls: ['./form-for-cell-sign-in.shared.component.scss']
})
export class FormForCellSignInComponent extends FormTypesComponent implements OnInit {
    public defaultSelectedCounty: number;
    public countries: ILoyaltyAppCountryAssignmentModel[] = [];

    constructor(
        @Inject(Tokens.CONFIG_TOKEN) public config: IConfig,
        public formBuilder: FormBuilder,
        public controllers: Controllers,
        public membersService: Services.MembersService,
        public modalsService: Services.ModalsService
    ) {
        super(config, formBuilder);
        this.formName = 'cell-sign-in';
    }

    ngOnInit(): void {
        this.loading$ = this.controllers.members.isMakingRequestsAsStatus$();

        this.compact = false;

        this.controllers.appSettings.appGetCounrtries$().subscribe((countries) => {
            this.countries = countries;

            this.formControl = this.formBuilder.group({
                countryPrefix: [
                    { value: '', disabled: false }
                ],
                cellNumber: [
                    { value: '', disabled: false },
                    {
                        validators: Validators.compose(
                            cellPhoneCommonValidators(this.countries)
                        ),
                    },
                ],
            });

            this.defaultSelectedCounty = [...this.countries].find((c) => c.IsDefault)?.Id || 222;
        });
    }

    public handleFormSubmit($event: Event): void {
        const { cellNumber, countryPrefix } = this.getFormValues();

        this.controllers.members.initSignIn(`${countryPrefix || ''}:${cellNumber}`);
    }

    public handleErrorButtonClick($event: Event): void {
        console.log('HANDLING BUTTON CLICK', $event, ($event.currentTarget as HTMLButtonElement).innerText);
    }
}
